import React, { Component } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { BROWSER } from './browser-detect'
import routes from './routes'
import './App.scss'

class App extends Component {
  componentDidMount() {
    this.handleIntroSessionVariable()
    this.ieHandler()
  }

  handleIntroSessionVariable = () =>
    setInterval(() => {
      localStorage.removeItem('noIntro')
    }, 300000)

  ieHandler = () => {
   
    if (BROWSER.isExplorer()) {
      BROWSER.handlePolyfill()
      alert(
        "Warning: We've detected you're browsing with Internet Explorer. Please upgrade your browser for optimal experience"
      )
    }
  }
  componentDidMount() {
    // setInterval(() => {
    //   const videos = document.querySelectorAll('video')
    //   console.log('these are all the videos in the app')
    //   console.log(videos)
    //   if (videos.length > 1) {
    //     for(let i = 0; i < videos.length; i ++) {
    //       for(let j = i + 1; j < videos.length; j ++) {
    //         if(videos[i].paused === false && videos[j].paused === false) {
    //           console.log("There are two playing videos")
    //           console.log(videos[i])
    //           videos[i].pause() 
    //           videos[i].currentTime = 0
    //         }
    //       }
    //     }
    //   }
    // }, 5000)
  }
  render() {
    return (
      <BrowserRouter>
        <div className="App">{routes}</div>
      </BrowserRouter>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js